<mat-card appearance="outlined" fxLayout="column" fxLayoutAlign="start stretch" [matTooltip]="commonChartInfoCard.HoverText" [ngStyle]="cardStyle">
    <mat-card-header>
        <mat-card-title>
            {{commonChartInfoCard.Title}}
        </mat-card-title>
        <mat-card-subtitle>
            {{commonChartInfoCard.Subtitle}}
        </mat-card-subtitle>
    </mat-card-header>

</mat-card>